// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M1.5 3.5H14.5M1.5 8H14.5M1.5 12.5H14.5'];
